import React from 'react';
import {Col, Flex, Form, Row, Select} from "antd";
import {t} from "i18next";

import ButtonBlack from "../../../../ui/buttons/ButtonBlack";
import useFilterOptions from "./useFilterOptions";

interface DataTotalsFilterProps {
  setDataTotalsFilter: Function,
}

export default function DataTotalsFilter({setDataTotalsFilter}: DataTotalsFilterProps) {
  const [filterForm] = Form.useForm();
  const {channelsOptions, factorsOptions} = useFilterOptions();

  const onSave = (values: any) => {
    setDataTotalsFilter(values);
  };

  return (
    <>
      <Form
        form={filterForm}
        name="models"
        onFinish={onSave}
        layout="vertical"
        autoComplete="off"
      >
        <Flex gap={'small'}>
          <Flex>
            <Flex gap={'small'}>
              <Form.Item
                name={'channels'}
              >
                <Select
                  style={{width: '100%', minWidth: '300px'}}
                  showSearch
                  allowClear
                  placeholder={t('planner.channelFilter')}
                  mode="multiple"
                  filterOption={false}
                  options={channelsOptions}
                />
              </Form.Item>
              <Form.Item
                name={'factors'}
              >
                <Select
                  style={{width: '100%', minWidth: '300px'}}
                  showSearch
                  allowClear
                  placeholder={t('planner.factorFilter')}
                  mode="multiple"
                  filterOption={false}
                  options={factorsOptions}
                />
              </Form.Item>
            </Flex>
          </Flex>
          <Flex justify={"flex-end"}>
            <ButtonBlack
              onClick={() => filterForm.submit()}
            >{t('planner.applyFilter')}</ButtonBlack>
          </Flex>
        </Flex>
      </Form>
    </>
  )
}
